module.exports = __webpack_public_path__ + "static/img/Ruiter-Lisa.d6a8912.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew_cast/nl/Ruiter-Lisa.jpg
// module id = dN/G
// module chunks = 1